import React from 'react';
import moment from 'moment-timezone';
import styled from 'styled-components';

import UsageSummaryPaneFragment from './UsageSummaryPaneFragment';
import { divideIntoNumericDigits } from '../../utils/common';

const StyledUsageSummaryPane = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 15px 0;
  border-style: solid;
  border-width: 1px 0;
`;

const showTimeUnit = (num, sym) => (num ? `${num}${sym}` : '');

const getFormattedSessionLength = (length) => {
  if (length < 1000) {
    return '0s';
  }

  const days = Math.floor(length / (86400 * 1000));
  const lengthWithoutDays = length - days * 86400 * 1000;
  return `${showTimeUnit(days, 'd')}
  ${showTimeUnit(moment.duration(lengthWithoutDays).hours(), 'h')}
  ${showTimeUnit(moment.duration(lengthWithoutDays).minutes(), 'm')}
  ${showTimeUnit(moment.duration(lengthWithoutDays).seconds(), 's')}`;
};

const UsageSummaryPane = ({ executing, sessions, avgSessionLength, uniqueUsers }) => (
  <StyledUsageSummaryPane>
    {!executing && !sessions && !avgSessionLength && !uniqueUsers ? (
      <span>No data yet</span>
    ) : (
      [
        <UsageSummaryPaneFragment
          key="sessions-fragment"
          executing={executing && !sessions}
          value={divideIntoNumericDigits(sessions)}
          description="Sessions"
        />,
        <UsageSummaryPaneFragment
          key="avg-session-length-fragment"
          executing={executing && !avgSessionLength}
          value={getFormattedSessionLength(avgSessionLength)}
          description="Avg Session Length"
        />,
        <UsageSummaryPaneFragment
          key="unique-users-count"
          executing={executing && !uniqueUsers}
          value={divideIntoNumericDigits(uniqueUsers)}
          description="Unique Users"
        />,
        <UsageSummaryPaneFragment
          key="session-per-user-fragment"
          executing={executing && (!uniqueUsers || !sessions)}
          value={divideIntoNumericDigits(Math.floor((sessions * 10) / uniqueUsers) / 10)}
          description="Sessions per User"
        />,
      ]
    )}
  </StyledUsageSummaryPane>
);

export default UsageSummaryPane;
